<template>
	<index-page />
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	import IndexPage from "@/components/index/index.vue"; // @ is an alias to /src

	@Component({
		components: {
			IndexPage
		}
	})
	export default class Index extends Vue {}
</script>
